import format from '../civic-champs-shared/utils/format'
import { LocationAddressType } from '../constants/location-address-type'

export interface VolunteerEventLocationFields {
  locationAddressType?: LocationAddressType | string | null
  locationIsAddress: boolean
  locationDetails?: string | null
  address?: string | null
  city?: string | null
  state?: string | null
  zip?: string | null
  mapPosition?: { lat: number; lng: number } | null
}

export const getVolunteerEventWhereLabel = ({
  locationAddressType,
  locationIsAddress,
  locationDetails,
  address,
  city,
  state,
  zip,
}: VolunteerEventLocationFields): string => {
  if (locationAddressType === LocationAddressType.PlusCode) {
    return locationDetails?.trim() || address?.trim() || ''
  }

  if (locationIsAddress) {
    if (city != null && address && address.includes(city)) {
      return address
    }
    return [address, city, [state, zip].filter(Boolean).join(' ')].filter(Boolean).join(', ')
  }

  return locationDetails?.trim() || ''
}

const hasUsableMapCoordinates = (
  mapPosition?: { lat: number; lng: number } | null,
): mapPosition is {
  lat: number
  lng: number
} => {
  if (!mapPosition) {
    return false
  }
  const { lat, lng } = mapPosition
  return Number.isFinite(lat) && Number.isFinite(lng) && !(lat === 0 && lng === 0)
}

export const getVolunteerEventMapEmbedProps = (
  fields: VolunteerEventLocationFields,
): { position?: { lat: number; lng: number }; address?: string } | null => {
  if (!fields.locationIsAddress) {
    return null
  }

  if (fields.locationAddressType === LocationAddressType.PlusCode) {
    if (hasUsableMapCoordinates(fields.mapPosition)) {
      return { position: fields.mapPosition }
    }
    const plusCode = fields.address?.trim()
    return plusCode ? { address: plusCode } : null
  }

  const formattedAddress = format.address({
    line1: fields.address || '',
    city: fields.city || '',
    state: fields.state || '',
    zip: fields.zip || '',
  })

  if (!formattedAddress.replace(/[, ]/g, '')) {
    return null
  }

  if (hasUsableMapCoordinates(fields.mapPosition)) {
    return { position: fields.mapPosition }
  }

  return { address: formattedAddress }
}
